module.exports = __webpack_public_path__ + "img/profile_sp.bfe2ad28.png";